import React, { ReactNode, useRef } from "react";
import styles from "./tabs.module.scss";
import wrapperHOC from "@Utils/wrapperHOC";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";

type TabsListTypes = {
  children: ReactNode;
  activeTab?: string;
  setActiveTab?: React.Dispatch<React.SetStateAction<string>>;
  className?: any;
  removeMargin?: boolean;
};

const TabsList = ({ children, className = "", removeMargin = false, ...rest }: TabsListTypes) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const scrollToEnd = (val: string) => {
    if (val === "Distance from City Centre") {
      const container: HTMLElement | null = containerRef.current;
      if (!container) return;
      container?.scrollTo({
        left: container?.scrollWidth,
        behavior: "smooth",
      });
    }
    if (val === "University") {
      const container: HTMLElement | null = containerRef.current;
      if (!container) return;
      container?.scrollTo({
        left: 0,
        behavior: "smooth",
      });
    }
  };
  return (
    <div
      ref={containerRef}
      className={formatClassNames(
        `${styles.tablist} ${className}`,
        removeMargin ? styles.removeMargin : "",
      )}
    >
      {React.Children.map(children, (child) => {
        if (React.isValidElement(child)) {
          return React.cloneElement(child, {
            ...(rest?.activeTab && { activeTab: rest?.activeTab }),
            ...(rest?.setActiveTab && { setActiveTab: rest?.setActiveTab, scrollToEnd }),
          });
        }
        return child;
      })}
    </div>
  );
};

export default wrapperHOC(TabsList, {
  componentName: "TabsList-Tabs-Global",
  showForChina: true,
});
